import { FEATURES, MODULES } from '@src/quince-site-common/src/constants/template-info'
import { sgtmServiceClient } from '@src/quince-site-common/src/utils/HttpClient'
import { captureException } from '@src/quince-site-common/src/utils/sentryUtil'

import { processResponseHeaders } from './utils/handleSgtmApi.utils'

export const handleSgtmApi = (
  eventData: Record<string, unknown>,
  event_name: string,
  event_key: string,
  shouldProcessResponseHeaders = false,
) => {
  const payload = {
    event: event_name,
    [event_key]: JSON.stringify(eventData),
  }
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  }
  sgtmServiceClient
    .post('/ecomm', payload, config)
    .then(res => {
      console.info('Track to sgtm success : ', res)
      if (shouldProcessResponseHeaders) {
        processResponseHeaders(res.headers)
      }
    })
    .catch((err: unknown) => {
      console.error('Track to sgtm failed : ', err)
      captureException(err, {
        module: MODULES.INTERNAL_ANALYTICS,
        feature: FEATURES.SGTM_API,
      })
    })
}
